import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Page, PageHeader, Card, EmptyState, DescriptionList } from "../../../../ui";
import "./aeReports.scss";

/**
 * Drill-down target from Demo Status Details. Query: ?date=YYYY-MM-DD.
 * Location state may include dateViewDetails when wired from callers.
 */
const AeReportsDateView: React.FC = () => {
  const [params] = useSearchParams();
  const date = params.get("date") || "";

  const backLink = (
    <Link to={`${process.env.PUBLIC_URL}/pages/ae-reports/demo-status-details`}>
      ← Back to Demo Status Details
    </Link>
  );

  return (
    <Page>
      <PageHeader eyebrow="AE Reports" title="Date view" actions={backLink} />
      <Card>
        {date ? (
          <DescriptionList items={[{ label: "Selected date", value: date }]} />
        ) : (
          <EmptyState
            title="No date selected"
            description="No date in the URL. Open this page from Demo Status Details."
          />
        )}
      </Card>
    </Page>
  );
};

export default AeReportsDateView;
